import { render } from "./LockerInstructions_4.vue?vue&type=template&id=079e3e97"
import script from "./LockerInstructions_4.vue?vue&type=script&lang=js"
export * from "./LockerInstructions_4.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__